import { RowMenu } from '@components/RowMenu';
import { RowMenuItem } from '@components/RowMenuItem';
import { IMenu } from '@hooks/useMenu';
import useMessage from '@hooks/useMessage';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { IRemessa } from '@model/Remessa';
import { useRemessaService } from '@services/RemessaService';
import React from 'react';

export type RemessaMenuProps = {
    menu: IMenu
    remessa: IRemessa
}

export function RemessaMenu ({ menu, remessa }: RemessaMenuProps) {
    const remessaService = useRemessaService();
    const message = useMessage();

    const handleBaixarArquivo = React.useCallback(() => {
        remessaService.baixarArquivo(remessa.remessaId)
            .catch(message.showBlobException);
    }, [message.showBlobException, remessa.remessaId, remessaService]);

    return (
        <RowMenu menu={menu}>
            <RowMenuItem 
                key={0} 
                onClick={menu.handleItemClick(handleBaixarArquivo)}
                text="Baixar Arquivo"
                icon={<CloudDownloadIcon />}
            />
        </RowMenu>
    )
}